import { singleFunctionTemplateIds } from '../responsibilities/single-function-template-ids';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';
import { assertIsDefined } from '../../../assertIsDefined';

export function issuesRecipientsForCore(functions, employees, organization) {
  const result: SelectDropdownOption[] = [];
  const employeeIds: string[] = [];
  const qualityManager = functions.find((f) => {
    return f.mainTemplateId === singleFunctionTemplateIds.qualityManager;
  });
  if (qualityManager) {
    const employee = employees.find((e) => {
      return e.uuid === qualityManager.employees[0];
    });
    if (employee) {
      employeeIds.push(employee.uuid);
    }
  }
  const recipientFunctionIds: number[] = [
    singleFunctionTemplateIds.qualityManager,
    singleFunctionTemplateIds.hseManager,
    singleFunctionTemplateIds.generalManager,
    singleFunctionTemplateIds.hrManager,
    singleFunctionTemplateIds.equipmentManager,
    singleFunctionTemplateIds.ictResponsible,
  ];
  const recipientFunctions = functions.filter((f) => {
    return f.mainTemplateId && recipientFunctionIds.includes(f.mainTemplateId);
  });
  const recipientFunctionEmployeeIds = recipientFunctions.map((f) => {
    return f.employees[0];
  });
  employees.forEach((e) => {
    if (!employeeIds.includes(e.uuid) && recipientFunctionEmployeeIds.includes(e.uuid)) {
      employeeIds.push(e.uuid);
    }
  });
  employeeIds.forEach((id) => {
    const employee = employees.find((e) => {
      return e.uuid === id;
    });
    if (employee) {
      const functionNames: string[] = recipientFunctions
        .filter((f) => {
          return f.employees[0] === id && f.name;
        })
        .map((f) => {
          return f.name ?? '';
        });
      let functionsList = functionNames.join(', ');
      if (functionNames.length > 2) {
        functionsList = functionNames.slice(0, 3).join(', ') + ' ...';
      }
      result.push({ value: id, text: employee.name + ' (' + functionsList + ')' });
    }
  });
  if (result.length === 0) {
    const e = employees.find((e) => e.email?.toLowerCase() === organization?.ownerEmail?.toLowerCase());
    assertIsDefined(e);
    result.push({ value: e.uuid, text: e.name });
  }
  return result;
}
